module.exports = __webpack_public_path__ + "media/images/application/icons/socials/icon-linkedin-black-11003566ef77392d3d7a641df675b5a6.svg";